module.exports = __webpack_public_path__ + "static/media/not-feeling-good-enough-large@3x.c7187789.png";